<template>
  <v-dialog v-model="show" width="70vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <v-row no-gutters>
          <v-col cols="12">
            <span> Relación lote </span>
          </v-col>
          <!-- <v-col>
            <span class="text-body-1"> {{productsSelected.}}</span>
          </v-col> -->
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="products"
                class="elevation-1"
                :loading="isfetching"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon
                    color="primary"
                    @click="openFillProductModal(item)"
                    :disabled="item.productType == 'KIT'"
                  >
                    mdi-basket-fill
                  </v-icon>
                </template>
                <template #[`item.lotes`]="{ item }">
                  <span class="text-caption" v-if="item.lotes.length == 0"
                    >------</span
                  >
                  <div v-else>
                    <!-- <span v-for="(lote, index) in item.lotes" :key="index">
                      {{ lote.loteId }}
                    </span> -->
                    <v-tooltip
                      bottom
                      v-for="(lote, index) in item.lotes"
                      :key="index"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on">
                          {{ lote.loteId }}
                        </v-chip>
                      </template>
                      <span> Dosis: {{ lote.doses }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template #[`item.presentation`]="{ item }">
                  <span>{{ item.presentation.name }}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Asignar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <SupplyPorductModal
      v-model="showSupplyPorductModal"
      v-if="showSupplyPorductModal"
      @fetchData="fetchParentDataStock"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapMutations, mapActions } from "vuex";
// components
import SupplyPorductModal from "@/components/dashboard/lote/modals/SupplyPorductModal.vue";
export default {
  components: {
    SupplyPorductModal,
  },
  data: () => ({
    loader: false,
    isLoading: false,
    isfetching: false,
    headers: [
      {
        text: "OP - Entrega",
        align: "start",
        sortable: false,
        value: "serial",
      },
      { text: "Cantidad", value: "qty" },
      { text: "Presentación", value: "presentation" },
      { text: "Lotes", value: "lotes" },
      { text: "Apartar", value: "action", align: "start" },
    ],
    products: [],
    showSupplyPorductModal: false,
  }),
  props: {
    value: Boolean,
    title: String,
  },
  computed: {
    ...mapState("lotes", ["productsSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("lotes", ["SET_PRODUCT_SELECTED"]),
    ...mapActions("order", ["getProductUpdated", "setAssignedProducts"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },

    async confirmation() {
      try {
        // FIND IF EXIST PRODUCT WITHOUT LOTE ASSIGNATION
        let productAssigned = this.products.filter(
          (element) => element.lotes.length == 0
        );
        let kits = this.products.filter(
          (element) => element.productType == "KIT"
        );
        if (productAssigned.length == 0 || kits.length > 0) {
          this.isLoading = true;
          let ids = this.products.map((object) => object._id);

          let paylaod = {
            ids: ids,
          };
          let response = await this.setAssignedProducts(paylaod);
          if (!response) throw response;
          this.$emit("assigned");
          this.$swal({
            icon: "success",
            title: `Asignación de productos exitosa`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "info",
            text: "No se puede marcar asignado un producto sin dosis",
            timeout: 3500,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al asignar productos, intente de nuevo`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoading = false;
    },
    openFillProductModal(item) {
      this.SET_PRODUCT_SELECTED(item);
      this.showSupplyPorductModal = true;
    },
    async updateOrderProducts() {
      try {
        this.isfetching = true;
        this.products = [];
        for (let item of this.productsSelected) {
          let payload = {
            productId: item._id,
          };
          let response = await this.getProductUpdated(payload);
          if (!response) throw response;
          this.products.push(response.productUpdated);
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar productos, intente de nuevo`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isfetching = false;
    },
    async fetchParentDataStock() {
      await this.updateOrderProducts();
      this.$emit("fetchData");
    },
  },
  async created() {
    await this.updateOrderProducts();
  },
};
</script>
